import { cn } from '@repo/ui/utils'
import { Skeleton } from '@repo/ui/skeleton'
import { Typography } from '@repo/ui/typography'
import React, { useState } from 'react'
import Image from 'next/image'
import { Globe } from 'lucide-react'
import { OrganizationBadge } from '../ui/OrganizationBadge'
import { Organization } from './OrganizationPage'

const BANNER_PLACEHOLDER_PATH = '/images/institutionBanner.webp'
const DEFAULT_REGION = 'Global'
const DEFAULT_ORG_NAME = 'AminoChain Organization'
const DEFAULT_DESCRIPTION = 'A biospecimen provider.'

interface OrganizationHeaderProps extends Organization {
  isOrgPage?: boolean
}

const WebsiteLink: React.FC<{ websiteUrl: string }> = ({ websiteUrl }) => (
  <a
    href={websiteUrl}
    target="_blank"
    rel="noopener noreferrer"
    className="absolute top-3 right-4 z-20 flex items-center justify-center w-8 h-8 rounded-full bg-white/80 hover:bg-white shadow-md transition lg:hidden"
    aria-label="Visit organization website"
  >
    <Globe className="w-5 h-5 text-slate-800" />
  </a>
)

export const OrganizationHeader: React.FC<OrganizationHeaderProps> = ({ isOrgPage = false, ...props }) => {
  const org = props as Organization

  const [bannerUrl, setBannerUrl] = React.useState(() => {
    const url = org?.bannerUrl
    return url && url.trim() ? url : BANNER_PLACEHOLDER_PATH
  })

  return (
    <header className="relative w-full h-32 bg-[#FCF1FD]">
      <Image
        src={bannerUrl}
        alt="Institution banner"
        fill
        className="object-cover object-center blur-[2px]"
        style={{ opacity: 0.5 }}
        onError={() => setBannerUrl(BANNER_PLACEHOLDER_PATH)}
      />

      {isOrgPage && org.websiteUrl && <WebsiteLink websiteUrl={org.websiteUrl} />}

      <div className="relative flex flex-col items-center justify-center gap-5 px-6 pt-5 w-full">
        <OrganizationBadge
          organization={{
            id: org.id,
            name: org.name ?? DEFAULT_ORG_NAME,
            logoUrl: org.logoUrl ?? undefined,
          }}
          className="bg-white border-white"
        />
      </div>
    </header>
  )
}
